"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _ssrWindow = require("ssr-window");

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var appVersion = (_ssrWindow.window.navigator && _ssrWindow.window.navigator.appVersion || '').toLowerCase();
var userAgent = (_ssrWindow.window.navigator && _ssrWindow.window.navigator.userAgent || '').toLowerCase();
var comparator = {
  '<': function _(a, b) {
    return a < b;
  },
  '<=': function _(a, b) {
    return a <= b;
  },
  '>': function _(a, b) {
    return a > b;
  },
  '>=': function _(a, b) {
    return a >= b;
  }
};

var compareVersion = function compareVersion(version, range) {
  var string = String(range);
  var n = Number(string.match(/\d+/) || NaN);
  var op = string.match(/^[<>]=?|/)[0];
  return comparator[op] ? comparator[op](version, n) : version === n || n !== n; // eslint-disable-line no-self-compare
};
/**
 * Utilities for working with the execution environment.
 * @module EnvironmentUtils
 */


var EnvironmentUtils = {
  /**
   * Determines whether the code is being executed in the browser.
   * @static
   * @function isBrowser
   * @example
   * EnvironmentUtils.isBrowser();
   * @returns {Boolean} - Whether the environment is the browser.
   */
  isBrowser: function isBrowser() {
    return typeof window !== 'undefined';
  },

  /**
   * Determines whether the code is being executed in iOS.
   * @static
   * @function isiOS
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isiOS();
   * @returns {Boolean} - Whether the environment is iOS.
   */
  isiOS: function isiOS() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return this.isiPhone(null, ua) || this.isiPad(null, ua) || this.isiPod(null, ua);
  },

  /**
   * Determines whether the code is being executed on an iPhone.
   * @static
   * @function isiPhone
   * @param {Number|String} [range] - The version range to test against.
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isiPhone();
   * EnvironmentUtils.isiPhone(9);
   * EnvironmentUtils.isiPhone('>=7');
   * EnvironmentUtils.isiPhone('<8');
   * @returns {Boolean} - Whether the environment is iPhone.
   */
  isiPhone: function isiPhone(range) {
    var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;
    // avoid false positive for Facebook in-app browser on ipad;
    // original iphone doesn't have the OS portion of the UA
    var match = this.isiPad(null, ua) ? null : ua.match(/iphone(?:.+?os (\d+))?/i);
    return match !== null && compareVersion(match[1] || 1, range);
  },

  /**
   * Determines whether the code is being executed on an iPad.
   * @static
   * @function isiPad
   * @param {Number|String} [range] - The version range to test against.
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isiPad();
   * EnvironmentUtils.isiPad(9);
   * EnvironmentUtils.isiPad('>=7');
   * EnvironmentUtils.isiPad('<8');
   * @returns {Boolean} - Whether the environment is iPad.
   */
  isiPad: function isiPad(range) {
    var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;
    var match = ua.match(/ipad.+?os (\d+)/i);
    return match !== null && compareVersion(match[1], range);
  },

  /**
   * Determines whether the code is being executed on an iPod.
   * @static
   * @function isiPod
   * @param {Number|String} [range] - The version range to test against.
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isiPod();
   * EnvironmentUtils.isiPod(9);
   * EnvironmentUtils.isiPod('>=7');
   * EnvironmentUtils.isiPod('<8');
   * @returns {Boolean} - Whether the environment is iPod.
   */
  isiPod: function isiPod(range) {
    var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;
    var match = ua.match(/ipod.+?os (\d+)/i);
    return match !== null && compareVersion(match[1], range);
  },

  /**
   * Determines whether the code is being executed in Android.
   * @static
   * @function isAndroid
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isAndroid();
   * @returns {Boolean} - Whether the environment is Android.
   */
  isAndroid: function isAndroid() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return /android/i.test(ua);
  },

  /**
   * Determines whether the code is being executed on an Android phone.
   * @static
   * @function isAndroidPhone
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isAndroidPhone();
   * @returns {Boolean} - Whether the environment is Android phone.
   */
  isAndroidPhone: function isAndroidPhone() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return /android/i.test(ua) && /mobile/i.test(ua);
  },

  /**
   * Determines whether the code is being executed on an Android tablet.
   * @static
   * @function isAndroidTablet
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isAndroidTablet();
   * @returns {Boolean} - Whether the environment is Android tablet.
   */
  isAndroidTablet: function isAndroidTablet() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return /android/i.test(ua) && !/mobile/i.test(ua);
  },

  /**
   * Determines whether the code is being executed on a Blackberry.
   * @static
   * @function isBlackberry
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isBlackberry();
   * @returns {Boolean} - Whether the environment is Blackberry.
   */
  isBlackberry: function isBlackberry() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return /blackberry/i.test(ua) || /bb10/i.test(ua);
  },

  /**
   * Determines whether the code is being executed on a Windows phone.
   * @static
   * @function isWindowsPhone
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isWindowsPhone();
   * @returns {Boolean} - Whether the environment is Windows phone.
   */
  isWindowsPhone: function isWindowsPhone() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return this.isWindows() && /phone/i.test(ua);
  },

  /**
   * Determines whether the code is being executed on a Windows tablet.
   * @static
   * @function isWindowsTablet
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isWindowsTablet();
   * @returns {Boolean} - Whether the environment is Windows tablet.
   */
  isWindowsTablet: function isWindowsTablet() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return this.isWindows() && !this.isWindowsPhone(ua) && /touch/i.test(ua);
  },

  /**
   * Determines whether the code is being executed on Windows.
   * @static
   * @function isWindows
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isWindows();
   * @returns {Boolean} - Whether the environment is Windows.
   */
  isWindows: function isWindows() {
    return /win/i.test(appVersion);
  },

  /**
   * Determines whether the code is being executed on a tablet.
   * @static
   * @function isTablet
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isTablet();
   * @returns {Boolean} - Whether the environment is a tablet.
   */
  isTablet: function isTablet() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return this.isiPad(null, ua) || this.isAndroidTablet(ua) || this.isWindowsTablet(ua);
  },

  /**
   * Determines whether the code is being executed on a mobile device.
   * @static
   * @function isMobileDevice
   * @param {String} [ua=navigator.userAgent] - The user agent to test against.
   * @example
   * EnvironmentUtils.isMobileDevice();
   * @returns {Boolean} - Whether the environment is a mobile device.
   */
  isMobileDevice: function isMobileDevice() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;
    return this.isiPhone(null, ua) || this.isiPod(null, ua) || this.isAndroidPhone(ua) || this.isBlackberry(ua) || this.isWindowsPhone(ua);
  },

  /**
   * Determines whether the code is being executed on a touch device.
   * @static
   * @function isTouchDevice
   * @example
   * EnvironmentUtils.isTouchDevice();
   * @returns {Boolean} - Whether the environment is a touch device.
   */
  isTouchDevice: function isTouchDevice() {
    return Boolean(_ssrWindow.document) && ('ontouchstart' in _ssrWindow.document.documentElement || 'DocumentTouch' in _ssrWindow.document.documentElement && _ssrWindow.document instanceof window.DocumentTouch);
  },

  /**
   * Determines whether the display has a high density.
   * @static
   * @function isHighDensityDisplay
   * @example
   * EnvironmentUtils.isHighDensityDisplay();
   * @returns {Boolean} - Whether the display is high density.
   */
  isHighDensityDisplay: function isHighDensityDisplay() {
    return _ssrWindow.window.matchMedia && (_ssrWindow.window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || _ssrWindow.window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || _ssrWindow.window.devicePixelRatio && _ssrWindow.window.devicePixelRatio > 1.3;
  }
};
var _default = EnvironmentUtils;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(appVersion, "appVersion", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/environment/environment.js");
  reactHotLoader.register(userAgent, "userAgent", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/environment/environment.js");
  reactHotLoader.register(comparator, "comparator", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/environment/environment.js");
  reactHotLoader.register(compareVersion, "compareVersion", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/environment/environment.js");
  reactHotLoader.register(EnvironmentUtils, "EnvironmentUtils", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/environment/environment.js");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/environment/environment.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();